export default {
  title: "Stands",
  total: "Total: {amount}",

  allowedStands: "Allowed for building",
  disallowedStands: "Not allowed for building",

  lookBtn: "View all stands",

  pluralize: ["stand", "stands"],

  modal: {
    allQuotas: "Quotas total:",
    allowedQuotas: "Allowed:",

    table: {
      standNumber: "Stand number",
      companyName: "Company name",
      buildingPermission: "Building permision",
      quotas: "Quotas"
    },

    status: {
      allowed: "Allowed",
      consideration: "Under consideration",
      notAllowed: "Not allowed"
    }
  }
};
